import { RGrid } from "@raiden/library-ui/components/RGrid";
import { Fragment } from "react";
import { CampaignCard } from "../../../components/Campaigns/Card";

/**
 * @typedef {object} Props
 * @property {import("@raiden/library-ui/types/Api/ApiResponse").ApiResponse<import("@raiden/library-ui/types/Campaign").Campaign[], any>[]} pages
 */
/**
 * @param {Props} props
 */
export function SimpleResultsGrid({ pages }) {
  return (
    <RGrid minCellWidth="250px">
      {pages.map((page, index) => (
        <Fragment key={index}>
          {page.data.map((campaign) => (
            <CampaignCard
              campaign={campaign}
              aspectRatio={1}
              key={campaign.id}
            />
          ))}
        </Fragment>
      ))}
    </RGrid>
  );
}
